import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Img,
  Button,
  Toastr,
} from "arv-reactcomponents";

import MobileNumberInput from "../../component/Login/MobileNumberInput";
import Anchor from "../../component/Anchor";
import { blackboltConfig, APPS, pageType, Endpoints } from "npmlinks-constants";

import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import { setPageType } from "../../utils";

@inject("StaticPageStore")
@observer
class Apps extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userMobNumber: "",
      showSuccessBlock: false,
    };

    this.handleUserMobNo = this.handleUserMobNo.bind(this);
    this.sendAppLink = this.sendAppLink.bind(this);
  }

  componentDidMount() {
    setPageType(pageType.getApp);
    Analytics.trackEvent({
      action: Event.action.LANDED,
      category: Event.category.GET_APP,
      label: Event.label.getSource(window.pageType),
    });
  }

  handleUserMobNo(mobileNumber) {
    if (mobileNumber.isValid) {
      this.setState({ userMobNumber: mobileNumber.value });
    }
  }

  sendAppLink() {
    const { userMobNumber } = this.state;
    if (userMobNumber && userMobNumber.length) {
      const object = {
        mobileNumber: userMobNumber,
      };
      this.props.StaticPageStore.sendNNNOWAppLink(object)
        .then(response => {
          if (response && response.status) {
            this.setState({ showSuccessBlock: true });
          }
        })
        .catch(error => {
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: blackboltConfig.ERROR_MSG,
            timeout: 3000,
          });
        });
    }
  }

  get getAppStoreBlock() {
    return (
      <div className="nw-apps-storeblock">
        <Anchor.component
          className="nw-apps-store"
          to={APPS.APP_STORE_PATH}
          href={APPS.APP_STORE_PATH}
        >
          <Img src={Endpoints.APP_STORE} />
        </Anchor.component>
        <Anchor.component
          className="nw-apps-store"
          to={APPS.PLAY_STORE_PATH}
          href={APPS.PLAY_STORE_PATH}
        >
          <Img src={Endpoints.PLAY_STORE} />
        </Anchor.component>
      </div>
    );
  }

  get successBlock() {
    return (
      <div className="nw-apps-appdetails">
        <h1 className="nw-apps-successblocktitle"> {APPS.SUCCESS_TITLE} </h1>
        <p className="nw-apps-successblockmesage"> {APPS.SUCCESS_MESSAGE} </p>
        {this.getAppStoreBlock}
      </div>
    );
  }

  get getAppDetailsBlock() {
    return (
      <div className="nw-apps-appdetails">
        <h1 className="nw-apps-blocktitle"> {APPS.TITLE} </h1>
        <p> {APPS.MESSAGE} </p>
        <div className="nw-apps-mobilenumberblock">
          <MobileNumberInput.component
            className="nwc-inp-secondary nw-apps-mobilenumberinput"
            name={APPS.NAME}
            placeholder={APPS.PLACEHOLDER}
            onChange={this.handleUserMobNo}
          />
          <Button
            className="nwc-btn nwc-btn-primary nw-apps-sendapplink"
            onClick={this.sendAppLink}
          >
            {APPS.BUTTON_LABEL}
          </Button>
        </div>
        {this.getAppStoreBlock}
      </div>
    );
  }

  render() {
    const { showSuccessBlock } = this.state;
    return (
      <GridContainer>
        <GridRow className="nw-apps-appscreencontainer">
          <GridColumn className="nwc-grid-col-sm">
            <Img
              className="nw-apps-appscreens"
              src={Endpoints.APP_SCREEN}
              alt={Endpoints.noImg}
            />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm nw-apps-contentblock">
            {showSuccessBlock ? this.successBlock : this.getAppDetailsBlock}
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn className="nw-apps-customerblocktitle">
            <h2> {APPS.CUSTOMER_BLOCK_TITLE} </h2>
          </GridColumn>
        </GridRow>
        <GridRow className="nwc-main-content-wrapper">
          {APPS.CUSTOMER_DETAILS.map(data => (
            <GridColumn className="nwc-grid-col-sm">
              <div className="nw-apps-customerblock">
                <div className="nw-apps-customerdetails">
                  <Img
                    className="nw-apps-customerimage"
                    src={Endpoints.feebackCustomerImage.IMAGE[data.ID]}
                  />
                  <div>
                    <h2 className="nw-apps-customername"> {data.NAME} </h2>
                    <Img
                      className="nw-apps-rating"
                      src={Endpoints.customerRating.RATING}
                    />
                  </div>
                </div>
                <div className="nw-apps-feedback"> {data.MESSAGE} </div>
              </div>
            </GridColumn>
          ))}
        </GridRow>
      </GridContainer>
    );
  }
}

const getFinalComponent = component =>
  inject("StaticPageStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Apps.wrappedComponent,
  component: Apps,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/Apps/index.js